<template>
	<div></div>
</template>
<script>
// eslint-disable-next-line import/extensions,import/no-unresolved
import useStore from 'webmd-cms-store/src/store';

import _find from 'lodash/find';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';

export default {
	name: 'SetRendered',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		const module = _find(this.data.module_data.shared_Modules.SharedModules, ['module_settings.title', 'hicbn']);
		module.module_settings = _pick(module.module_settings, 'title');
		module.module_data = _pick(module.module_data, 'groups');

		module.module_data.groups.group = module.module_data.groups.group.map((g) => _omit(g, ['group_link_view']));

		module.module_data.groups.group.forEach((g) => {
			// eslint-disable-next-line no-param-reassign
			g.link_items.link_item = g.link_items.link_item.map((l) => _omit(l, ['article_link_view', 'link_chronic_id']));
		});

		const data = {
			module_data: {
				shared_Modules: {
					SharedModules: [module],
				},
			},
		};
		this.store.cms.UPDATE_STATE({ key: this.chronicId, value: data });
	},
};
</script>
<style scoped>
</style>
